import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { ProformViewStates } from '../../../dtos/proforms.dto';
import { ProformsSubmissionService } from '../../../services/proforms/proforms-submission.service';
import {
  ProformFieldTypes,
  ProFormsQuestionAPIResponse,
} from '../../../types/responses/proforms.responses';

@Component({
  selector: 'app-proforms-question',
  standalone: false,
  templateUrl: './proforms-question.component.html',
  styleUrl: './proforms-question.component.scss',
})
export class ProformsQuestionComponent implements OnInit, OnChanges {
  @Input() question: ProFormsQuestionAPIResponse;

  @Input() viewState: ProformViewStates = ProformViewStates.PREVIEW;

  @Input() submitted = false;

  @Input() showMissed = 0;

  @Input() showAnswers = 0;

  subs: Subscription[] = [];

  FieldTypes = ProformFieldTypes;

  viewStates = ProformViewStates;

  isInvalid = false;

  // null if no correct answers
  isIncorrect: boolean | null = null;

  constructor(private proformsSubmissionService: ProformsSubmissionService) {}

  ngOnInit(): void {
    if (this.question) {
      if (this.viewState === this.viewStates.GRADED && this.showMissed) {
        this.proformsSubmissionService.currentSubmission.subscribe(
          (submission) => {
            if (
              submission?.answers &&
              (this.question.field_type === this.FieldTypes.CHECKBOX ||
                this.question.field_type === this.FieldTypes.RADIO)
            ) {
              const selectedAnswerIds = submission.answers
                .filter((a) => a.proform_form_question_id === this.question.id)
                .map((a) => a.proform_form_question_answer_option_id);

              const correctAnswerOptionIds = this.question.answerOptions
                .filter((a) => a.is_correct)
                .map((a) => a.id);

              if (correctAnswerOptionIds.length > 0) {
                this.isIncorrect =
                  selectedAnswerIds.length !== correctAnswerOptionIds.length ||
                  selectedAnswerIds.some(
                    (id) => !correctAnswerOptionIds.includes(id)
                  );
              } else {
                this.isIncorrect = null; // No correct answers, set to null
              }
            }
          }
        );
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['submitted']) {
      this.proformsSubmissionService.newSubmission.subscribe((submission) => {
        if (submission) {
          const answer = submission.answers.find(
            (a) => a.proform_form_question_id === this.question.id
          );

          if (this.question.required && this.submitted) {
            this.isInvalid = !answer;
          } else {
            this.isInvalid = false;
          }
        }
      });
    }
  }
}
